module.exports = __webpack_public_path__ + "media/src/images/icon__check-ad71085464cc2aac096839282b7dc274.png";